module.exports = __webpack_public_path__ + "img/bjcheck.d78789d6.png";